import { State } from '../address';
import { Relationship, Sex } from '../common';
import { Payor } from '../patient/insuranceInformation';

interface SubscriberAddress {
  address: string | null;
  unitNumber: string | null;
  city: string | null;
  state: State | null;
  zip: string | null;
}

interface DetailedCoverageSubscriber {
  subscriberFirstName: string | null;
  subscriberLastName: string | null;
  subscriberSex: Sex | null;
  subscriberAddress: SubscriberAddress | null;
}

export enum EligibilityResponse {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Inactive = 'INACTIVE',
  NotFound = 'NOT_FOUND',
  PayorNotSupported = 'PAYOR_NOT_SUPPORTED',
}

export interface RealTimeEligibilityResults {
  status: EligibilityResponse;
  groupNumber: string | null;
  coverageStartDate: string | null;
  payor?: Payor | string | null;
  patientRelationshipToSubscriber: Relationship | null;
  subscriber: DetailedCoverageSubscriber | null;
}
